import React, { useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import useBackdropClose from "../../hooks/useBackdropClose";
import { SUPPORTED_LANGUAGES, changeLanguage } from "../../i18n";
import englishFlag from "../../assets/flags/english.png";
import italianFlag from "../../assets/flags/italian.png";
import romanianFlag from "../../assets/flags/romanian.png";
import dutchFlag from "../../assets/flags/dutch.png";
import {
  Overlay, Modal, ModalTitle, Subtitle, LanguageList, LanguageRow,
  Flag, LanguageName, Check, ActionRow, CancelButton, SaveButton,
} from "./styles";

const FLAGS = {
  en: englishFlag,
  it: italianFlag,
  ro: romanianFlag,
  nl: dutchFlag,
};

const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3.5"
       strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 6L9 17l-5-5" />
  </svg>
);

/**
 * Seleccion de idioma de la interfaz. El cambio no se aplica al pulsar una
 * fila sino al guardar, para que Cancel deje la interfaz como estaba.
 */
const LanguageModal = ({ onClose }) => {
  const { t, i18n } = useTranslation();
  const [selected, setSelected] = useState(i18n.language);

  const handleSubmit = (e) => {
    e.preventDefault();
    changeLanguage(selected);
    onClose();
  };

  // Portal a <body>: desde la barra lateral (position: fixed + z-index) el
  // overlay quedaria atrapado en su contexto de apilamiento, bajo la top bar.
  return createPortal(
    <Overlay {...useBackdropClose(onClose)}>
      <Modal onClick={(e) => e.stopPropagation()} onSubmit={handleSubmit}>
        <ModalTitle>{t("language.title")}</ModalTitle>
        <Subtitle>{t("language.subtitle")}</Subtitle>

        <LanguageList role="radiogroup" aria-label={t("language.title")}>
          {SUPPORTED_LANGUAGES.map(({ code, name }) => {
            const isSelected = code === selected;
            return (
              <LanguageRow
                key={code}
                role="radio"
                aria-checked={isSelected}
                aria-label={name}
                tabIndex={0}
                $selected={isSelected}
                onClick={() => setSelected(code)}
                onKeyDown={(e) => {
                  // Espacio y Enter seleccionan, como haria un radio nativo.
                  if (e.key === " " || e.key === "Enter") {
                    e.preventDefault();
                    setSelected(code);
                  }
                }}
              >
                <Flag src={FLAGS[code]} alt="" />
                <LanguageName lang={code}>{name}</LanguageName>
                <Check $selected={isSelected}><CheckIcon /></Check>
              </LanguageRow>
            );
          })}
        </LanguageList>

        <ActionRow>
          <CancelButton type="button" onClick={onClose}>
            {t("language.cancel")}
          </CancelButton>
          <SaveButton type="submit">{t("language.save")}</SaveButton>
        </ActionRow>
      </Modal>
    </Overlay>,
    document.body
  );
};

export default LanguageModal;
